import { format } from "date-fns";
import { id } from "date-fns/locale";
import { Filter, RotateCcw, Search, ListOrdered, Download, Settings } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { generatePdfFromElement } from "../../../../util/PdfClient";
import "../../../../assets/style/modal-print.css";
import { TagihanItem, TagihanLoketItem } from "../../../../model/Hublang";
import { CSV } from "../../../../util/ExportFile";
import { fetchGetTagihanLoket, fetchGetTagihanLoketNsb, fetchPutTagihanLoket } from "../../../../controller/dashboard/Loket";
import DatePicker from "react-datepicker";
import { getCache } from "../../../../util/Cache";
import { PengaduanTeknik } from "../../../../model/Pengaduan";
import { fetchGetLaporanPengaduanTeknik } from "../../../../controller/dashboard/Pengaduan";

export const Teknik = () => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditDateModal, setShowEditDateModal] = useState(false);
    const [selectedPengaduanTeknik, setSelectedPengaduanTeknik] = useState<PengaduanTeknik | any>(null);
    // const [selectedTagihanLoket, setSelectedTagihanLoket] = useState<TagihanLoketItem | null>(null);

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState<PengaduanTeknik>({
        no                  : 0, 
        no_pelanggan        : 'all', 
        nama                : 'all',
        no_telp             : 'all',
        deskripsi           : 'all',
        deskripsi_eksekusi  : 'all',
        alamat              : 'all',
        tanggal             : 'all',
        rating              : 0,
        responden           : 'all',
        eksekutor           : 'all'
    });

    const [statusLength, setStatusLength] = useState('10');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [pengaduanData, setPengaduanData] = useState<PengaduanTeknik[]>([]);
    const uniqueRating = Array.from(new Set(pengaduanData.map(item => item.rating))).filter(Boolean);

    const filteredPengaduan = pengaduanData.filter(plg => {
        const matchesSearch =plg.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plg.nama.includes(searchTerm) ||
        plg.no_pelanggan.includes(searchTerm) ||
        plg.no_telp.includes(searchTerm) ||
        plg.alamat.includes(searchTerm) ||
        plg.tanggal.includes(searchTerm);

        const matchesStatus = 
        (statusFilter.tanggal === 'all' || plg.tanggal === statusFilter.tanggal) &&
        (statusFilter.rating === 0 || plg.rating === statusFilter.rating) &&
        (statusFilter.responden === 'all' || plg.responden === statusFilter.responden) &&
        (statusFilter.eksekutor === 'all' || plg.eksekutor === statusFilter.eksekutor)

        return matchesSearch && matchesStatus;
    });
 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPengaduan = filteredPengaduan.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPengaduan.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataPhotoMeter = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetLaporanPengaduanTeknik(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any, idx : number) => ({
                    no                  : idx + 1,
                    nama                : item.nama?.trim() || "Tidak ada data",
                    no_pelanggan        : item.no_pelanggan || "Tidak ada data",
                    deskripsi           : item.deskripsi    || "Tidak ada data",
                    deskripsi_eksekusi  : item.kecamatan    || "Tidak ada data",
                    alamat              : item.alamat       || "Tidak ada data",
                    tanggal             : item.tanggal      || "Tidak ada data",
                    rating              : item.rating       || 0,
                    responden           : item.responden    || "Tidak ada data",
                    eksekutor           : item.eksekutor    || "Tidak ada data"
                }));

                const sortedData = processedData;
                setPengaduanData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPengaduanData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPengaduanData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetail = (tl : TagihanLoketItem) => {
        setSelectedPengaduanTeknik(tl);
        setShowDetailModal(true);
    }
    
    const handleShowDetailClose = () => {
      setSelectedPengaduanTeknik(null);
      setShowDetailModal(true);
    }

    // const handleShowEdit = async (tagihan?: any) => {
    //   setSelectedTagihan(tagihan);
    //   setShowDetailModal(false);
    //   setShowEditDateModal(false);
    //   setShowEditModal(true);
    //   console.log(selectedTagihan);
    //   console.log(showEditModal);
    // }

    // const handleShowEditDate = (tagihan?: any) => {
    //   setSelectedTagihan(tagihan);
    //   setShowEditDateModal(true);
    //   setShowEditModal(false);
    //   setShowDetailModal(false);
    // }

    const ExportCSV = (data : any) => {
        const list = data;
        console.log(list.data);

        return (
            <button 
                onClick={async () => {
                    try {
                       await CSV(list.data, "Export_Pengaduan");
                    } catch (error) {
                        console.error("Error exporting CSV:", error);
                    }
                }}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <Download className="w-4 h-4 mr-2" />
                { "Export" }
            </button>
        )
    }
    
    const RenderTablePengaduan = ({ filteredData, 
        // onOpenDetail 
    }: { 
        filteredData: PengaduanTeknik[] | null; 
        // onOpenDetail : (pengaduan: PengaduanTeknik) => void;
    }) => (
      <>
        {
          filteredData && filteredData.length > 0 ? (
            filteredData.map((plg, idx) => (
              <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                    {idx + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.nama}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    {plg.no_pelanggan}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.no_telp}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.deskripsi}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.deskripsi_eksekusi}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.alamat}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.tanggal}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.rating}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.responden}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.eksekutor}
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                    ><Settings /></button> */}
                    {/* <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors"
                    ><Plus /></button> */}
                {/* </td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={18} className="text-center py-4 text-gray-500">
                Tidak ada data
              </td>
            </tr>
          )
        }
      </>
    );
    
    const DetailPreviewModal = ({ pelangganTLDetail, stateShowModal } : { 
        pelangganTLDetail: TagihanLoketItem | null; 
        stateShowModal: (show: boolean) => void | false;
        onClose: () => void;
    }) => {
        const [data, setData] = useState<any>({ data: [] });
        const [loadingData, setLoadingData] = useState<boolean>(false);
        const [tanyaPrintId, setTanyaPrintId] = useState<number | null>(null)
    
        useEffect(() => {
            const fetchData = async () => {
                setLoadingData(true);
                const result = await fetchGetTagihanLoketNsb(pelangganTLDetail?.nsb || '');
                setData(result);
                setLoadingData(false);
            };
            fetchData();
        }, [pelangganTLDetail]);

        const handlePrint = (idx: number) => {
          setTanyaPrintId(idx);
          setTimeout(() =>  {
            setTanyaPrintId(null);
          }, 5000);
        }
        
    
        const sortedData = data.data.slice().sort((a : any, b : any) => {
            if (a.TAHUN !== b.TAHUN) return b.TAHUN - a.TAHUN;
            return b.BULAN - a.BULAN;
        });
    
        return(
            <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-9xl mx-4 p-4 overflow-hidden">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">Detail Pelanggan : {pelangganTLDetail?.nama} </h3>
                            <div className="text-xl font-semibold text-gray-500">Pelanggan : {pelangganTLDetail?.pelanggan}</div>
                            <div className="text-xl font-semibold text-gray-500">Klasf : {pelangganTLDetail?.klasf}</div>
                        </div>
                        <button
                            onClick={() => stateShowModal(false)}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                            >
                            ✕
                        </button>
                    </div>
                
                    <div className="space-y-4 overflow-y-auto max-h-[70vh]">
                        <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NO</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NAMA</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NSB</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PERIODE</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">KLASF</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MLALU</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MKINI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PAKAI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">VOL.</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">H.AIR</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ADM</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">DENDA</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SUBSIDI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">TOTAL</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">TOTAL BAYAR</th>
                                </tr>
                            </thead>
                            <tbody>
                    { sortedData && sortedData.length > 0 ? (
                                <>
                                  {sortedData.map((tagihan: any, idx: number) => (
                                      <tr key={idx} className="hover:bg-gray-100 transition-colors">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{idx + 1}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.NAMA}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.NSB}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.BULAN} - {tagihan.TAHUN}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.KLAS}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MLALU}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MKINI}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.PAKAI}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.VOLUME}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.HAIR}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.ADM}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.DENDA}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.SUBSIDI}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.TOTAL}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.TOTAL_BYR}</td>

                                      </tr>
                                  ))}
    
                                  {/* 🔹 Tambahkan baris total */}
                                  <tr className="bg-gray-100 font-semibold text-gray-900">
                                      <td colSpan={9} className="px-6 py-3 text-right">
                                      TOTAL
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.HAIR) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.ADM) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.DENDA) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.SUBSIDI) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.TOTAL) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.TOTAL_BYR) || 0), 0).toLocaleString()}
                                      </td>
                                      <td></td>
                                  </tr>
                                </>
                                ) : (
                                <tr>
                                    { loadingData ?  
                                        <td colSpan={15} className="text-center py-4 text-gray-500">
                                            Sedang Loading . . . 
                                        </td>
                                        :
                                        <td colSpan={15} className="text-center py-4 text-gray-500">
                                            Tidak ada data tagihan 
                                        </td>
                                    }
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
    
                </div>
            </div>
            </>
        );
    }
    const PrintModal = ({ show, tagihan, pelanggan, onClose, onSubmit } : {
        show: boolean;
        tagihan: TagihanItem | any;
        pelanggan: TagihanLoketItem | null;
        onClose: () => void;
        onSubmit: (data: TagihanItem) => void;
      }
    ) => {

        const previewRef = useRef<HTMLDivElement | null>(null); 
            
        if (!show) return null;

        const handleSavePDF = async () => {
          if (!previewRef.current) return alert("Preview not ready");
          try {
            const nsbPelanggan = pelanggan?.nsb
              ? pelanggan.nsb.replace(/\s+/g, "_").toUpperCase() // ubah spasi jadi underscore
              : "NSB";
            const namaPelanggan = pelanggan?.nama
              ? pelanggan.nama.replace(/\s+/g, "_").toUpperCase() // ubah spasi jadi underscore
              : "PELANGGAN";
            const tanggalSekarang = format(new Date(), "yyyy-MM-dd_HH-mm");
            const namaFile = `Pelunasan-${nsbPelanggan}-${namaPelanggan}-${tanggalSekarang}.pdf`;
            await generatePdfFromElement(previewRef.current, namaFile, { format: "a4", orientation: "portrait" });
            // beri notifikasi sukses kalau mau
            onClose();
          } catch (err) {
            console.error("Generate PDF error", err);
            alert("Gagal membuat PDF: " + String(err));
          }
        }

        const handlePrint = async (status : string) => {
          const dataSend = {...tagihan, ...pelanggan}
          await fetchPutTagihanLoket(dataSend);

          if(status === 'print'){
            printArea();
          } else {
            handleSavePDF();
          }
        };

        const printArea = () => {
          if (!previewRef.current) return;
          const html = `
            <html>
              <head>
                <title>Print Preview</title>
                <style>
                  body { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, "Roboto Mono", "Courier New", monospace; font-size:13px; color:#111827; padding:10px; }
                  pre { white-space: pre; line-height:1.25; font-size:13px; }
                </style>
              </head>
              <body>
                ${previewRef.current.innerHTML}
                <script>
                  window.onload = function () {
                    window.print();
                    // optionally close after printing:
                    // setTimeout(() => window.close(), 200);
                  };
                </script>
              </body>
            </html>
          `;
          const w = window.open("", "_blank", "width=600,height=800");
          if (!w) {
            alert("Popup blocked. Izinkan popup untuk mencetak.");
            return;
          }
          w.document.open();
          w.document.write(html);
          w.document.close();
          onClose();
        }

        const formattedHariIni = tagihan.mode_print == 'transfer' ? format(new Date(tagihan.tanggal_bayar_string), "dd-MMM-yyy", { locale: id }) : format(new Date(), "dd-MMM-yyy", { locale: id });

        // Build receipt string using provided data (fallback values if undefined)
        const buildReceipt = async () => {
          const nama = pelanggan?.nama ?? "NAMA PELANGGAN";
          const noSmb = pelanggan?.nsb ?? "0000000";
          const klasf = pelanggan?.klasf ?? "gol";
          const pelangganText = pelanggan?.pelanggan ?? "Reguler";
          const kec = pelanggan?.kecamatan ?? "MARISA";
          const desa = pelanggan?.desa ?? "DESA";
          const tglBayar = formattedHariIni;
          const petugas_cache = await getCache("current_user");
          const petugas = petugas_cache.username;
          const bulan = tagihan?.BULAN ?? "September";
          const tahun = tagihan?.TAHUN ?? "2025";
          const mlalu = tagihan?.MLALU ?? "0";
          const mkini = tagihan?.MKINI ?? "0";
          const pakai = tagihan?.PAKAI ?? "0";
          const vol = tagihan?.VOLUME ?? "0";
          const hair = tagihan?.HAIR ?? "0";
          const adm = tagihan?.ADM ?? "0";
          const subsidi = tagihan?.SUBSIDI ?? "0";
          const denda = tagihan?.DENDA ?? "0";
          const total = tagihan?.TOTAL ?? "0";
          const total_byr = tagihan?.TOTAL_BYR ?? "0";

    return [
`
Jl.Trans Sulawesi Bunt.Tengah
Kabupaten Pohuwato
==================================
NAMA        : ${nama}
NO.SMB/GOL  : ${noSmb} / ${klasf}
PELANGGAN   : ${pelangganText}
KECAMATAN   : ${kec}
DESA/KEL    : ${desa}
TGL BAYAR   : ${tglBayar}
PETUGAS     : ${petugas}
-----------------------------------
  BULAN  : ${bulan}-${tahun}
  M.LALU : ${mlalu}
  M.KINI : ${mkini}
  PAKAI  : ${pakai}        VOL  : ${vol}
  HAIR   : ${hair}
  ADM    : ${adm}
  DENDA  : ${denda}
====================================
  TOTAL         : ${total}
  TOTAL BANSOS  : ${subsidi}
  TOTAL BAYAR   : ${total_byr}

TUNGGAKAN 2(DUA) BULAN
BERTURUT-TURUT AKAN DIADAKAN
PEMUTUSAN SAMBUNGAN TANPA
PEMBERITAHUAN TERLEBIH DAHULU
TERIMAKASIH`
    ].join("\n");
};
      
        return (
          <div className="modal-overlay" role="dialog" aria-modal="true">
            <div className="modal" aria-label="Print preview modal">
              {/* Header */}
              <div className="modal-header">
                <div>
                  <div className="modal-title">
                    {pelanggan?.nama ?? "Nama Pelanggan"} - { tagihan?.mode_print } - { tagihan?.tanggal_bayar_string }
                  </div>
                  <div className="modal-sub">Tagihan {tagihan?.BULAN ?? ""} - {tagihan?.TAHUN ?? ""}</div>
                </div>

                <div className="modal-controls">
                  <button className="btn btn-icon" onClick={onClose} aria-label="Close">✕</button>
                </div>
              </div>

              <div className="container">
                <button className="btn btn-primary" onClick={() => handlePrint('print')}>Print</button>
                <button className="btn btn-primary" onClick={() => handlePrint('pdf')}>Simpan sebagai pdf</button>
              </div>

              <div className="preview-container">
                <div className="preview-scroll">
                  <div ref={previewRef} className="print-only">
                    <div style={{ fontWeight: "bold", marginBottom: "-14px" }}>PERUMDAM TIRTA MOOLANGO</div>
                    <pre>{buildReceipt()}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }

    const PrintDateModal = ({ show, tagihan, pelanggan, onClose, onSubmit } : {
        show: boolean;
        tagihan : TagihanItem | any;
        pelanggan : TagihanLoketItem | null; 
        onClose: () => void;
        onSubmit: (tagihan : any) => void;
      }
    ) => {
      const [dateGet, setDateGet] = useState<Date | any>();

      const handleSubmit = () => {
        let tagihanSubmit : any;
        let date_get = dateGet.toString();
        const date_temp = new Date(date_get);
        const year = date_temp.getFullYear();
        const month = String(date_temp.getMonth() + 1).padStart(2, '0');
        const day = String(date_temp.getDate()).padStart(2, '0');
        const formattedDate = `${year}/${month}/${day}`;
        tagihanSubmit = { ...tagihan, tanggal_bayar : formattedDate, tanggal_bayar_string : date_get };
        onSubmit(tagihanSubmit);
      };
      
      return (
        <div className="modal-overlay fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="modal bg-white rounded-xl shadow-lg w-[400px] p-6">
            <div className="modal-header flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-lg font-semibold">
                {pelanggan?.nama ?? "Nama Pelanggan"} - Masukkan Tanggal
              </h2>
              <button className="btn btn-icon text-gray-500 hover:text-black" onClick={onClose}>
                ✕
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="text-xs text-gray-500 uppercase block mb-1">
                  Pilih Tanggal
                </label>
                <DatePicker
                  selected={dateGet}
                  onChange={(date) => setDateGet(date)}
                  placeholderText="Pilih tanggal bayar"
                  dateFormat="yyyy-MM-dd"
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full"
                  isClearable
                />
              </div>

              <div className="flex justify-end">
                <button className="btn btn-primary" onClick={handleSubmit}>Pilih Tanggal</button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? pengaduanData.length : statusLength))
    }, []);

    return (
      <>
        {/* Controls 1 */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                {/* Rating */}
                <div className="col-span-1 md:col-span-2">
                  <div className="relative">
                      <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <select
                      value={statusFilter.rating}
                      onChange={(e) => setStatusFilter({ ...statusFilter, rating: Number(e.target.value) })}
                      className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                      <option value="all">Pelanggan</option>
                      {uniqueRating.map((item, idx) => (
                          <option value={item} key={idx}>{item}</option>
                      ))}
                      </select>
                  </div>
                </div>
            </div>
        </div>

        {/* Controls 2*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              {/* Filter */}
              <button 
                onClick={initDataPhotoMeter}
                disabled={loading}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                {loading ? "Memuat..." : "Muat Ulang"}
              </button>

              <ExportCSV data={pengaduanData}/>
            </div>

            <div className="flex space-x-3">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Cari nama atau NIK..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                />
              </div>

              {/* Length*/}
              <div className="relative">
                <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <select
                  value={statusLength}
                  onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? pengaduanData.length : e.target.value))}}
                  className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option> 
                  <option value="500">500</option>
                  <option value="all">Tampil Semua</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NSB
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO. TELP
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DESKRIPSI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DESKRIPSI EKSEKUSI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ALAMAT
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    TANGGAL
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    RATING
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    RESPONDEN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    EKSEKUTOR
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                        <RenderTablePengaduan filteredData={currentPengaduan} 
                            // onOpenDetail={handleShowDetail}
                        />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? pengaduanData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{pengaduanData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPengaduan.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPengaduan.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>

        {/* {showDetailModal && <DetailPreviewModal pelangganTLDetail={selectedTagihanLoket} stateShowModal={setShowDetailModal} onClose={handleShowDetailClose}/>}
        {showEditModal && <PrintModal show={showEditModal} onClose={() => { setShowEditModal(false); setShowEditDateModal(false); setShowDetailModal(true); } } tagihan={selectedTagihan} pelanggan={selectedTagihanLoket} onSubmit={(updated) => {setShowEditModal(false);}} />}
        {showEditDateModal && <PrintDateModal show={showEditDateModal} onClose={ () => { setShowEditModal(false); setShowEditDateModal(false); setShowDetailModal(true); } } tagihan={selectedTagihan} pelanggan={selectedTagihanLoket} onSubmit={handleShowEdit} />} */}
      </>
    )
};